import { useNavigate } from "react-router-dom";
import { Search, Globe } from "lucide-react";

export default function UtilityBar() {
  const navigate = useNavigate();

  return (
    <div
      data-testid="utility-bar"
      className="relative z-40 bg-midnight text-ivory/80 text-[11px] sm:text-xs"
    >
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-2 px-4 py-1.5 sm:px-8 lg:px-16">
        <p className="font-serif italic tracking-wide text-ivory/75">
          Ad Iesum per Mariam — “To Jesus through Mary”
        </p>
        <div className="flex items-center gap-3 sm:gap-5">
          <span className="hidden items-center gap-1.5 sm:flex" aria-label="Language">
            <Globe className="h-3.5 w-3.5 text-gold" strokeWidth={1.8} />
            <span className="font-mono uppercase tracking-widest">EN</span>
          </span>
          <button
            type="button"
            data-testid="utility-search-button"
            onClick={() => navigate("/apparitions")}
            aria-label="Search the apparitions and shrines"
            className="flex items-center gap-1.5 transition-colors hover:text-ivory"
          >
            <Search className="h-3.5 w-3.5" strokeWidth={1.8} />
            <span className="hidden sm:inline font-mono uppercase tracking-widest">Search</span>
          </button>
        </div>
      </div>
    </div>
  );
}
